import Decimal from 'decimal.js';

export function isPositive(value: Decimal): boolean {
    return value.toDecimalPlaces(0, Decimal.ROUND_DOWN).gt(new Decimal(0));
}
